<section class="hero">
  <div class="container hero__inner position-relative z-1">
    <div class="row">
      <div class="col-12 col-lg-6 hero__content">
        <h1 class="hero__title display-2 mb-3">Base+</h1>
        <h2 class="hero__title mb-3">Stay connected & contactable</h2>
        <p class="hero__subtitle mb-4">
          Keeping your details connected to your pet is crucial to reuniting you. Join millions of UK pet owners who trust us with their pets.
        </p>
        <div class="d-flex flex-wrap justify-content-center gap-3 mb-4">
          <button type="button" [disabled]="!identibasePlusAvailable" (click)="buyIdentibasePlusSubscription()" class="btn ui-btn ui-btn--primary fw-bold">Buy now</button>
          <a [routerLink]="[]" fragment="our-plans" class="btn ui-btn ui-btn--outline-light fw-bold">Compare our plans</a>
        </div>
        <app-trustbox theme="dark"></app-trustbox>
      </div>
    </div>
  </div>

  <div class="hero__image-col">
    <div class="hero__image-wrapper">
      <img
        src="/assets/images/identibase/identibasePlus/header-image.png"
        alt="Person lying on a bed with their dog, looking at their phone"
        class="hero__image">
    </div>
  </div>
</section>

<section class="show-up py-5" id="how-we-show-up">
  <div class="container position-relative text-center pb-5">
    <h2 class="show-up__title display-4 mb-5">Why choose an Base+?</h2>
    <div class="row g-4">
      <div class="col-12 col-md-3" *ngFor="let card of plan1ShowUpCards">
        <app-icon-card 
          [iconSrc]="card.iconSrc"
          [iconHeight]="card.iconHeight"
          [iconWidth]="card.iconWidth"
          [iconCreamBackgorund]="true"
          [title]="card.title" 
          [description]="card.description" 
          [blackDescription]="true" 
          variant="white">
        </app-icon-card>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-3">
    <button
    type="button"
    class="btn ui-btn ui-btn--primary ui-btn--lg why-choose-button"
    [disabled]="!identibasePlusAvailable"
    (click)="buyIdentibasePlusSubscription()"
    >
      Get yours today
    </button>
  </div>
</section>
<section class="get-in-touch py-5">
  <div class="container" id="our-plans">
    <h2 class="get-in-touch__title display-4 text-center mb-3">Our Plans</h2>
    <p class="get-in-touch__subtitle text-center mx-auto mb-5">Find the right level of coverage to ensure your pet is always protected and your contact details are kept up to date.</p>
  </div>
  <div class="container">
    <app-plan-comparison-table></app-plan-comparison-table>
    <span class="comparison-table-sub-text">*Prices exclude local VAT where applicable. Coverage terms and conditions apply. Unlimited details updates valid while subscription is active.</span>
  </div>
</section>
<div>
  <app-trust-section [title]="trustTitle" [subtitle]="trustSubtitle"></app-trust-section>
</div>
